<!-- Videoconferencia Agendada -->
<ng-container *ngIf="!mostrarCalendario && agendamentoAtual; else calendarioVideoconferencia">
  <div role="tabpanel" class="tab-pane tab-pane-mobile">
    <div
      style="background-color: #77c8e517 !important"
      role="alert"
      class="mt-5 alert row col-md-12 round alert-icon-left alert-arrow-left alert-info alert-dismissible mb-2 custom-alert-mobile">
      <span class="alert-icon"><i class="fa fa-1x fa-exclamation"></i></span>
      <div class="bold text-white content-container-mobile">
        <h4 class="bold mt-2 mb-2" *ngIf="this.stepAtual <= propostaEnum.VIDEO_CONFERENCIA; else naoEhVideoConferencia">
          Você tem uma videoconferência marcada!
        </h4>
        <ng-template #naoEhVideoConferencia>
          <h4 class="bold mt-2 mb-2">Sua videoconferência foi realizada!</h4>
        </ng-template>
        <h5 class="bold">
          <i class="fa fa-calendar-o"></i>
          Quando:
          {{ formatarDataParaExibir(agendamentoAtual) }}
        </h5>
        <h5 class="bold mt-2">
          <i class="fa fa-video-camera"></i>
          Evento:
          {{ agendamentoAtual.titulo }}
        </h5>
        <div
          class="buttons-mobile"
          *ngIf="this.stepAtual == propostaEnum.VIDEO_CONFERENCIA && podeCadastrarEditar && ehColaborador">
          <a
            [href]="agendamentoAtual.link"
            target="_blank"
            class="btn-success btn mt-2 btn-round white btn-min-width box-shadow-4 ml-2">
            <i class="fa fa-video-camera mr-1"></i>
            Entrar na chamada
          </a>
          <a
            class="btn-danger btn mt-2 btn-round white btn-min-width box-shadow-4 ml-2"
            (click)="onModalConfirmarDeleteEventoBeneficiario(agendamentoAtual.id)">
            <i class="fa fa-trash mr-1"></i>
            Cancelar Agendamento
          </a>
        </div>
        <div *ngIf="this.stepAtual == propostaEnum.VIDEO_CONFERENCIA && !ehColaborador">
          <a [href]="agendamentoAtual.link" target="_blank" class="btn-success btn mt-2 btn-round white box-shadow-4">
            <i class="fa fa-video-camera"></i>
            Entrar na chamada
          </a>
          <a
            class="btn-danger btn mt-2 btn-round white box-shadow-4"
            (click)="onModalConfirmarDeleteEventoBeneficiario(agendamentoAtual.id)">
            <i class="fa fa-trash"></i>
            Cancelar Agendamento
          </a>
        </div>
      </div>
    </div>
    <div
      *ngIf="ehColaborador && this.stepAtual == propostaEnum.VIDEO_CONFERENCIA && podeCadastrarEditar"
      class="form-actions mb-1 float-right mt-3"
      style="text-align: right; margin-top: 10px">
      <app-declinio-proposta
        [stepAtual]="stepAtual"
        (propostaDeclinada)="receberDeclinio($event)"></app-declinio-proposta>
    </div>
  </div>
</ng-container>
<!-- Calendario -->
<ng-template #calendarioVideoconferencia>
  <section>
    <div class="col-12">
      <h1 class="text-center mb-3">
        <b>Agende sua Videoconferência</b>
      </h1>
    </div>
    <div class="row justify-content-center align-items-center">
      <button
        class="btn-seta"
        (click)="semanaAnterior()"
        [disabled]="semanaOffset === 0"
        [ngClass]="{'btn-seta-desabilitado': semanaOffset === 0}">
        <i class="fa fa-chevron-left"></i>
      </button>
      <ul class="d-flex justify-content-center flex-wrap mb-0">
        <li
          class="item-carrossel"
          *ngFor="let item of listaSemana"
          [class.ativo]="item.data === dataSelecionadaAtual"
          [class.desabilitado]="item.desabilitado"
          (click)="!item.desabilitado && dataSelecionada(item.data)">
          <span>{{ item.data }}</span>
          <br />
          <span>{{ item.diaSemana }}</span>
        </li>
      </ul>
      <button class="btn-seta" (click)="proximaSemana()">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>
    <!-- horários disponiveis -->
    <div class="col-md-12 mt-3" *ngIf="listaHorariosManha.length > 0 || listaHorariosTarde.length > 0">
      <h2 class="preto-geia mb-2">Horários Disponíveis</h2>
      <div class="d-flex justify-content-around">
        <!-- manhã -->
        <div class="col-md-5 cards-horarios" *ngIf="listaHorariosManha.length > 0">
          <h3 class="preto-geia text-center mb-1"><b>Manhã</b></h3>
          <ul class="d-flex flex-wrap p-0 justify-content-center">
            <li
              class="mb-1 mr-1 badge badge-success badges-horarios"
              *ngFor="let horario of listaHorariosManha"
              (click)="agendarVideoConferencia(horario.horainicio, horario.horafim)">
              {{ horario.horainicio }} - {{ horario.horafim }}
            </li>
          </ul>
        </div>
        <!-- tarde -->
        <div class="col-md-5 cards-horarios" *ngIf="listaHorariosTarde.length > 0">
          <h3 class="preto-geia text-center mb-1"><b>Tarde</b></h3>
          <ul class="d-flex flex-wrap p-0 justify-content-center">
            <li
              class="mb-1 mr-1 badge badge-info badges-horarios"
              *ngFor="let horario of listaHorariosTarde"
              (click)="agendarVideoConferencia(horario.horainicio, horario.horafim)">
              {{ horario.horainicio }} - {{ horario.horafim }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- sem horário -->
    <div class="col-md-12 mt-5" *ngIf="listaHorariosManha.length === 0 && listaHorariosTarde.length === 0">
      <div class="alert alert-warning text-center" style="border-radius: 10px; font-size: 1.2rem">
        <i class="fa fa-info-circle mr-1"></i>
        Sem horário disponível para o dia selecionado.
      </div>
    </div>
    <div
      *ngIf="temPortabilidade"
      class="alert round  alert-icon-left alert-arrow-left alert-dismissible mb-2 mt-2 {{
        corAlertaTipoJudicializacao
      }}"
      role="alert">
      <span class="alert-icon"><i class="fa fa-bell"></i></span>
      <span>
        <strong>
          Sua proposta contempla uma portabilidade com prazo de expiração em
          {{ dataExpiraPropostaPortabilidade }}. Agende sua videoconferência o quanto antes.
        </strong>
      </span>
    </div>
    <div
      *ngIf="ehColaborador && podeCadastrarEditar"
      class="form-actions mb-1 float-right mt-3"
      style="text-align: right; margin-top: 10px">
      <app-declinio-proposta></app-declinio-proposta>
    </div>
  </section>
</ng-template>
<!-- Modal Apagar Evento -->
<ng-template #templateModalApagar>
  <app-modal-simples [title]="titleModal" (cancel)="fecharModal(); modalRef.hide()">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <h5 class="text-center" style="font-weight: bold; font-size: 17px">Gostaria de cancelar este evento?</h5>
          <div class="mt-1 mb-1 text-center">
            <button
              class="btn-danger mr-2 btn btn-round white btn-min-width box-shadow-4"
              (click)="fecharModal(); modalRef.hide()">
              <i class="fa fa-thumbs-down mr-1"></i>
              Não
            </button>

            <button
              *ngIf="!mostrarCalendario"
              class="btn-success btn btn-round white btn-min-width box-shadow-4"
              (click)="cancelarAgendamentoBeneficiario(agendamentoAtual.id)">
              <i class="fa fa-thumbs-up mr-1"></i>
              Sim
            </button>
          </div>
        </div>
      </div>
    </div>
  </app-modal-simples>
</ng-template>
<!-- Criar Evnto Meet Beneficiario -->
<ng-template #templateModalAgendarMeet>
  <app-modal-simples [title]="titleModal" (cancel)="fecharModal(); modalRef.hide()">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="container">
            <h3 class="mb-2 bold">Gostaria de confirmar o agendamento:</h3>
            <form>
              <div class="col-md-12">
                <h4 class="bold mb-1">
                  <i class="fa fa-check-circle"></i>
                  Título do Evento: Videoconferência
                </h4>
                <h4 class="bold mb-1">
                  <i class="fa fa-calendar-o"></i>
                  Quando:
                  {{ formatarDataParaExibir(diaSelecionado) }}
                </h4>
              </div>

              <div class="mt-1 mb-1">
                <button
                  class="btn-warning btn btn-round white btn-min-width box-shadow-4 mr-2"
                  (click)="cancelarAgendamento()">
                  <i class="fa fa-times mr-1"></i>
                  Cancelar
                </button>
                <button
                  class="btn-success btn btn-round white btn-min-width box-shadow-4 mr-2"
                  (click)="criarEventoVideoConferencia(diaSelecionado)">
                  <i class="fa fa-check mr-1"></i>
                  Confirmar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </app-modal-simples>
</ng-template>
<!-- Loading -->
<ngx-spinner type="ball-newton-cradle" [fullScreen]="true" bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff">
  <p style="color: white">Carregando...</p>
</ngx-spinner>
